import { AggregatedQuoteError } from '../sdk/aggregatedQuote/errors/aggregatedQuoteError.js';
import { AmountMismatchError } from '../sdk/aggregatedQuote/errors/amountMismatchError.js';
import { getAggregatedQuoteExactIn } from '../sdk/aggregatedQuote/getAggregatedQuoteExactIn.js';
import '@defuse-protocol/internal-utils';

function isFailedQuote(quote) {
    return "type" in quote;
}
async function queryQuote(input, { signal, } = {}) {
    try {
        const aggregateQuote = await getAggregatedQuoteExactIn({
            aggregatedQuoteParams: {
                tokensIn: input.tokensIn,
                tokenOut: input.tokenOut,
                amountIn: input.amountIn,
                balances: input.balances,
                waitMs: input.waitMs,
            },
            config: {
                fetchOptions: { signal },
            },
        });
        return {
            tag: "ok",
            value: {
                quoteHashes: aggregateQuote.quoteHashes,
                expirationTime: aggregateQuote.expirationTime,
                tokenDeltas: aggregateQuote.tokenDeltas,
            },
        };
    }
    catch (err) {
        if (err instanceof AggregatedQuoteError) {
            const quoteError = err.errors.find((e) => e.quote != null);
            if (quoteError?.quote) {
                return {
                    tag: "err",
                    value: {
                        reason: `ERR_${quoteError.quote.type}`,
                    },
                };
            }
            return {
                tag: "err",
                value: {
                    reason: "ERR_NO_QUOTES",
                },
            };
        }
        if (err instanceof AmountMismatchError) {
            return {
                tag: "err",
                value: {
                    reason: "ERR_UNFULFILLABLE_AMOUNT",
                    shortfall: err.shortfall,
                    overage: err.overage,
                },
            };
        }
        throw err;
    }
}

export { isFailedQuote, queryQuote };
//# sourceMappingURL=quoteService.js.map
